import axios from "axios";
import React, { useState } from "react";
import { useHistory } from "react-router";
import SideBar from "../SideBar/SideBar";

const AddBook = () => {

  const [imageURL, setImageURL] = useState(null);
  const [newBook, setNewBook] = useState({});

  const history = useHistory();


  const handleImageChange = (e) => {
    console.log(e.target.files[0]);
    const imageData = new FormData();
    imageData.set("key", "758a6992daaebc4e2d183d1afdb6c292");
    imageData.append("image", e.target.files[0]);

    axios.post('https://api.imgbb.com/1/upload', imageData)
    .then(function (response) {
      setImageURL(response.data.data.display_url);

      console.log(response.data.data.display_url);

    })
    .catch(function (error){
      console.log(error);
    })
    
  };

  const handleOnBlur = e => {
    const newBookInfo = newBook;
    newBookInfo[e.target.name] = e.target.value;
    newBookInfo.image = imageURL;
    setNewBook(newBookInfo);
  }

  const handleSubmit = e => {
    e.preventDefault();

    fetch('https://infinite-cliffs-81680.herokuapp.com/addBooks',{
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(newBook),
        })
        .then(res => res.json())
        .then(data => {
          alert("Your book info is successfully added")

          history.replace('/')
        })
  }
  

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-4">
          <SideBar></SideBar>
        </div>
        <div className="col-md-8 border border-3 border-success p-4">
          <h3>Add Books</h3>
          <hr />
          <form onSubmit={handleSubmit}>
            <div class="mb-3">
              <label for="bookName" class="form-label">
                Book Name
              </label>
              <input onBlur={handleOnBlur} type="text" class="form-control" id="bookName" name="bookName" placeholder="Book Name" required/>
            </div>
            <div class="mb-3">
              <label for="authorName" class="form-label">
                Author Name
              </label>
              <input onBlur={handleOnBlur} type="text" class="form-control" id="authorName" name="authorName" placeholder="Author Name" required/>
            </div>
            <div class="mb-3">
              <label for="price" class="form-label">
                Price
              </label>
              <input onBlur={handleOnBlur} type="text" class="form-control" id="price" name="price" placeholder="Price" required/>
            </div>
            <div class="mb-3">
              <label for="image" class="form-label">
                Upload Image
              </label>
              <input
                type="file"
                class="form-control"
                id="image"
                onChange={handleImageChange}
                required
              />
            </div>

            <button type="submit" class="btn btn-primary">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddBook;
